import { render } from "./FileSelector.vue?vue&type=template&id=320f8466"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__